import { setTimeAggregation as setTimeAggregationDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    aggregation?: String,
}

export const setTimeAggregation = ({
    aggregation,
    eventEmitter
}: Props) => {
    setTimeAggregationDiagram(aggregation);
};

